import { SNSClient, PublishCommand } from '@aws-sdk/client-sns';

// Initialize SNS client
const snsClient = new SNSClient({
  region: 'us-east-1', // Change to your AWS region
  credentials: {
    accessKeyId: process.env.REACT_APP_AWS_ACCESS_KEY_ID,
    secretAccessKey: process.env.REACT_APP_AWS_SECRET_ACCESS_KEY,
  },
});

// SMS Service for GradedWash
export const smsService = {
  // Send SMS notification
  async sendSMS(phoneNumber, message) {
    try {
      const params = {
        Message: message,
        PhoneNumber: phoneNumber,
        MessageAttributes: {
          'AWS.SNS.SMS.SMSType': {
            DataType: 'String',
            StringValue: 'Transactional', // or 'Promotional'
          },
        },
      };

      const command = new PublishCommand(params);
      const result = await snsClient.send(command);
      
      console.log('SMS sent successfully:', result.MessageId);
      return { success: true, messageId: result.MessageId };
    } catch (error) {
      console.error('SMS sending failed:', error);
      return { success: false, error: error.message };
    }
  },

  // Send new match notification
  async sendMatchNotification(phoneNumber, matchName) {
    const message = `🎉 You have a new travel match on GradedWash! ${matchName} wants to connect. Check your app now!`;
    return this.sendSMS(phoneNumber, message);
  },

  // Send meet reminder
  async sendMeetReminder(phoneNumber, meetTitle, meetTime) {
    const message = `📅 Reminder: Your meet "${meetTitle}" is in 1 hour at ${meetTime}. See you there!`;
    return this.sendSMS(phoneNumber, message);
  },

  // Send account verification
  async sendVerificationCode(phoneNumber, code) {
    const message = `🔐 Your GradedWash verification code is: ${code}. Valid for 10 minutes.`;
    return this.sendSMS(phoneNumber, message);
  },

  // Send welcome message
  async sendWelcomeMessage(phoneNumber, userName) {
    const message = `�� Welcome to GradedWash, ${userName}! Start your journey by taking our personality quiz and finding travel companions.`;
    return this.sendSMS(phoneNumber, message);
  },
};

export default smsService; 